import React, { useEffect, useState } from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";

import { FaPlus } from "react-icons/fa";
import { MdModeEdit } from "react-icons/md";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import ColumnTable from "../embrillTable/ColumnTable";
import { organizationDataColumns } from "../embrillTable/variables/organization";
import { fetchAsyncGetOrganization } from "redux/organizationSlice";
import OrganizationForm from "components/allForm/Organization/OrganizationForm";

const AllOrganization = () => {
  const [addNewModal, setAddNewModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [orgEditData, setOrgEditData] = useState(null);
  const [orgListData, setOrgListData] = useState([]);
  const currUser = useSelector((state) => state.auth.currUser);
  const [loading, setLoading] = useState(false);
  const [role,setRole] = useState('')  

  useEffect(()=>{
    if(currUser && currUser?.auth){

      const auth = currUser?.auth;
      const roleObj = auth && auth?.length > 0 && auth.find((item)=> item?.module === 'Organization');
      if(roleObj){

        setRole(roleObj?.access)
      }
    }
   
  },[currUser])


  const organizationList = useSelector((state) => state.organizationData);
  const dispatch = useDispatch();
  const handleModalOpen = () => {
    setAddNewModal(true);
  };
  const handleModalClose = () => {
    setAddNewModal(false);
    setOpenEditModal(false);
    setOrgEditData(null);
  };

  useEffect(() => {
    const fetchOrganizations = async () => {
      setLoading(true);
      try {
        await dispatch(fetchAsyncGetOrganization());
      } catch (error) {
        console.error("Failed to fetch organizations:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrganizations();
  }, [dispatch]);

  useEffect(() => {
    if (organizationList && organizationList.length > 0) {
      const tableData = organizationList.map((data, index) => {
        return {
          _id:data?._id,
          no: index + 1,
          name: data.name,
          type: data?.orgTyp?.name,
          email: data.mail,
          gstNo: data.gstNo,
          panNo: data.pnNo,
          phone: data.ph || "-",
          action: (
            <div className="d-flex">
              <MdModeEdit
                className="me-2"
                color="blue"
                size={16}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  handleRowClick(e,data._id)
                }}
              />
             
            </div>
          ),
        };
      });
      setOrgListData(tableData);
    } else {
      setOrgListData([]);
    }
  }, [organizationList,role]);

  
  const handlerRefreshData = () => {
    dispatch(fetchAsyncGetOrganization());
  };

  const handleRowClick = (e,_id)=>{
    e.stopPropagation();
    const data = organizationList.filter((item)=> item?._id === _id)
    setOpenEditModal(true);
    setOrgEditData(data[0]);
    handleModalOpen();
  }
  const textColor = useColorModeValue("secondaryGray.900", "white");

  if (loading) {
    return (
      <SpinnerLoader/>
    );
  }
  return (
    <>
       <Box display="flex" className="mx-0" justifyContent="space-between">
       <Box display="flex">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
          mt={5}
          mx={2}
        >
          Organization
        </Text>
       
        </Box>
        <Box display="flex" mt={4} className="add-new-btn">
          <Box
            display="flex"
            alignItems="center"
            className="new-btn"
            onClick={handleModalOpen}
          >
            <FaPlus size={12} className="new-plus-icon"/> New
          </Box>
            
        </Box>
     
      </Box>
      <Box pt={{ base: "40px", md: "10px", xl: "10px" }}>
        <ColumnTable
          columnsData={organizationDataColumns}
          tableData={orgListData}
          type={"Organization"}
          role={role}
          openInfoModal = {handleRowClick}
          expenseType = 'organization'

        />
      </Box>
      {addNewModal && (
        <OrganizationForm
          openModel={addNewModal}
          closeModel={handleModalClose}
          isEdit={openEditModal}
          editData={orgEditData}
          refreshList={handlerRefreshData}
          role={role}

        />
      )}
    </>
  );
};

export default AllOrganization;